import merge from 'lodash/merge';

import { Util } from '@baifendian/adhere';

import reactPro from '@/components/system/SystemTheme/theme/eVehicle/reactPro';
import Config from '@/lib/config';

import _token from './token';

export default media => {
  const base = reactPro(media);

  const _tokenMap = _token(media);

  return merge(base, {
    components: {
      SystemBaseSearchTable: {
        isUsePadding: true,
        isUseRadius: false,
        isUseSearchWrapperGap: false,
        isUseSearchFormToolBarGap: false,
        systemSearchTableTableWrapperTheadBackgroundColor: `url(${Config.searchTableThGg}) no-repeat rgba(182, 138, 53, 0.04)`,
        systemSearchTableTableWrapperTheadBackgroundSize: 'cover',
        systemSearchTableTableWrapperTheadThNotCellFixBackgroundColor:
          'transparent',
        systemSearchTableTableWrapperTheadThBefore: 'none',
        systemSearchTableTableWrapperTheadThAfter: 'none',
      },
      SystemPage: {
        borderRadius: `${Util.pxToRem(16, media.designWidth, media)} ${Util.pxToRem(16, media.designWidth, media)} 0 0`,
        backgroundColor: '#fff',
      },
      SystemHeader: {
        menuMenuTabsAntTabsTabBtnFirstChildColor: '#fff',
        menuMenuTabsActiveAntTabsTabBtnFirstChildColor: '#fff',
        menuMenuTabsAntTabsTabBtnPadding: `0 ${Util.pxToRem(10, media.designWidth, media)}`,
        menuMenuTabsAntTabsTabBtnBorderRadius: `${Util.pxToRem(4, media.designWidth, media)}`,
        menuMenuTabsActiveAntTabsTabBtnBackgroundColor: _tokenMap.get(
          'common-primary-color'
        ).value,
        horizontalHeight: `${Util.pxToRem(92, media.designWidth, media)}`,
        horizontalLogoWrapTitleColor: '#fff',
        actionsUserInfoColor: '#fff',
        actionsLogOutColor: '#fff',
        actionsSeparationColor: '#fff',
        actionsUserIconColor: '#fff',
      },
      SystemLangChangeWithDark: {
        backgroundColor: 'transparent',
      },
      SystemLangChange: {
        iconColor: '#fff',
      },
      SystemDirectionChange: {
        imgColor: '#fff',
      },
      SystemCard: {
        border: '1px solid #dfdfdf',
        headTitleFontSize: `${Util.pxToRem(16, media.designWidth, media)}`,
      },
    },
    'form-item': {},
    lib: {
      BasicLayout: {
        antMenuSubmenuTitleContentFontSize: `${Util.pxToRem(13, media.designWidth, media)}`,
        antMenuSubmenuTitleContentLineHeight: `${Util.pxToRem(22, media.designWidth, media)}`,
        antMenuInlineBackground: 'transparent',
        antMenuItemSelectedBackgroundColor: 'transparent',
        antMenuItemSelectedTitleContentPadding: `${Util.pxToRem(8, media.designWidth, media)} ${Util.pxToRem(12, media.designWidth, media)}`,
        antMenuItemSelectedTitleContentColor: _tokenMap.get(
          'common-primary-color'
        ).value,
        antMenuItemSelectedTitleContentBackground: `
        linear-gradient(
          270deg,
          rgba(240, 189, 100, 0) 0%,
          #f0bd64 100%
        )
      `,
        antMenuItemSelectedTitleContentBorderRadius: `${Util.pxToRem(18, media.designWidth, media)} 0 0 ${Util.pxToRem(18, media.designWidth, media)}`,
        menuIconTextFontSize: `${Util.pxToRem(12, media.designWidth, media)}`,
        menuIconTextLineHeight: `${Util.pxToRem(18, media.designWidth, media)}`,
        antMenuItemTitleContentFontSize: `${Util.pxToRem(13, media.designWidth, media)}`,
        antMenuItemTitleContentLineHeight: `${Util.pxToRem(22, media.designWidth, media)}`,
        antMenuItemOnlyChildMenuIconTextPaddingLeft: 0,
        sliderMenuBarTriggerColor: '#ffe8b7',
        antMenuSubmenuTitleContentColor: '#ffe8b7',
        antMenuSubmenuArrowBeforeColor: '#ffe8b7',
        antMenuSubmenuArrowAfterColor: '#ffe8b7',
        menuTitleIconColor: '#ffe8b7',
        menuIconTextColor: '#fff',
        antMenuItemTitleContentColor: '#ffe8b7',
        sliderDarkBackgroundColor: 'transparent',
        borderRadius: `${Util.pxToRem(16, media.designWidth, media)}`,
        sliderBackgroundColor: `
          linear-gradient(
            180deg,
            rgba(117, 81, 6, 0.86) 0%,
            rgba(62, 42, 0, 0.9) 100%
          )
        `,
        mainWrapperBackgroundColor: '#fff',
        breadcrumbWrapperBackgroundColor: '#fff',
        mainWrapperPadding: `0 ${Util.pxToRem(25, media.designWidth, media)} ${Util.pxToRem(25, media.designWidth, media)} ${Util.pxToRem(25, media.designWidth, media)}`,
      },
    },
    app: {
      background: `url('${Config.bgPath}') lightgray 50% / cover no-repeat`,
      logoImgWidth: 'auto',
      logoImgHeight: 64,
      // verticalBodyPadding: `0 ${Util.pxToRem(24, media.designWidth, media)} ${Util.pxToRem(24, media.designWidth, media)} ${Util.pxToRem(24, media.designWidth, media)}`,
    },
    appComponents: {},
    appLib: {},
    'app-form-item': {},
    pages: {},
  });
};
